import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import RichTextBoxViewModel from '@/ViewModels/Controls/RichTextBoxViewModel';
import RichTextBox from '@/Controls/RichTextBox';
import LocatorHelper from '@/Utility/LocatorHelper';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import ResourceManager from '@/Management/ResourceManager';
import Utilities from '@/Utility/Utilities';

export default class RichTextBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private WindowViewModel = ComponentManager.getViewModel<typeof WindowViewModel>('WindowViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private RichTextBoxViewModel = ComponentManager.getViewModel<typeof RichTextBoxViewModel>('RichTextBoxViewModel');
    private RichTextBox = ComponentManager.getControl<typeof RichTextBox>('RichTextBox');

    /**
     * @override
     */
    public viewModel: RichTextBoxViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel();

        this.control = new this.RichTextBox(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, (newVal) => {
            return (newVal?.length ?? 0) <= this.viewModel.maxLength;
        }, (_) => {
            return ResourceManager.getInstance().get("RICHTEXTBOX_MAXLENGTHREACHED");
        });
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, (value: string): boolean => {
            return Utilities.validateInputForInvalidCharacters(value);
        });

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: this.viewModel?.value() || ''
        }
    }

    private createViewModel(): RichTextBoxViewModel {
        let length = this.detailViewItem.length;

        if (isNaN(length) || length === 0) {
            length = 255;
        }

        return new this.RichTextBoxViewModel({
            factory: this,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            isFocusable: this.isFocusable,
            isSummaryViewMode: this.isSummaryViewMode,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            maxLength: length,
            window: new this.WindowViewModel({
                parentLocator: this.locator,
                locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'window'),
                width: 1000,
                isModal: true,
                isOpen: false,
                allowClose: true,
                headline: new this.LabelViewModel({
                    caption: ''
                })
            })
        });
    }
}

ComponentManager.setFactory('RichTextBox', RichTextBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');